import { debounce } from "./debounce";
import getWindow from "./window";

function chooseDebounce(callback, debounceMs) {
  return debounceMs > 0 ? debounce(callback, debounceMs) : callback;
}

function maybeObserve(observer, element, autoObserve) {
  if (element && autoObserve) observer.observe(element);
}

export function setIntersectionObserver({
  element,
  options,
  handleIntersectionData,
  observeIntersectionOnce,
  debounceMs = 200,
  autoObserve = true,
}) {
  const Window = getWindow();
  const shouldCreate = !!element || autoObserve === false;
  if (!shouldCreate) return;
  let io = null;

  const helpers = {
    observe: (el) => {
      if (io && el) io.observe(el);
    },
    unobserve: (el) => {
      if (io && el) io.unobserve(el);
    },
  };

  const base = (entries) => {
    entries.forEach((entry = {}) => {
      if (typeof handleIntersectionData === "function") {
        handleIntersectionData(entry, helpers, element);
      }
      if (observeIntersectionOnce && entry.isIntersecting && element) {
        helpers.unobserve(element);
      }
    });
  };

  const callback = chooseDebounce(base, debounceMs);

  io = new Window.IntersectionObserver(callback, options);
  maybeObserve(io, element, autoObserve);
  return io;
}

export function unsetIntersectionObserver(element, observer) {
  if (!!element && !!observer) {
    observer.unobserve(element);
  }
}
